import { CareerReducer } from "./careers";
import { ContactReducer } from "./contact";
import { NavReducer } from "./nav";
import { ServicesReducer } from "./services";
import { UserReducer } from "./user";
import { combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

const LOGOUT = "LOGOUT";

// 1. Combine your reducers into an internal 'appReducer'
const appReducer = combineReducers({
  nav: NavReducer,
  user: UserReducer,
  services: ServicesReducer,
  contacts: ContactReducer,
  careers: CareerReducer,
});

// 2. Export a wrapper function to intercept the LOGOUT action
export const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    // Clear Redux Persist storage
    storage.removeItem("persist:293939fk");

    // Set state to undefined to force all reducers to reset to their initial states
    state = undefined;
  }

  return appReducer(state, action);
};
